<div class="container-fluid">
    <app-report reportId="pylDashboard" screen="DASHBOARDPYL"></app-report>
  </div>